import { styled } from 'baseui'

export const Container = styled('footer', ({ $theme }) => ({
    backgroundColor: 'black',
    padding: '2rem 1rem',
    display: 'flex',
    justifyContent: 'flex-start',
    flexDirection: 'column',

    [$theme.mediaQuery.large]: {
        padding: '2.5rem 4rem'
    }
}))

export const DropdownWrapper = styled('div', ({ $theme }) => ({
    maxWidth: '200px',
    marginTop: '20px'
}))

export const CopyrightText = styled('div', ({ $theme }) => ({
    fontFamily: 'Albert Sans',
    fontSize: '16px',
    fontWeight: 700,
    color: 'white',
    minWidth: '160px !important;'
}))

export const BottomWrapper = styled<'div', { $isViewPortMobile: boolean }>('div', ({ $isViewPortMobile }) => ({
    display: 'flex',
    alignItems: 'center',
    marginTop: $isViewPortMobile ? '80px' : '40px',
    maxWidth: '100%',
    flexWrap: 'wrap'
}))

export const LinksWrapper = styled<'div', { $isViewPortMobile: boolean }>('div', ({ $isViewPortMobile }) => ({
    display: 'flex',
    width: '80%',
    justifyContent: $isViewPortMobile ? 'flex-start' : 'center'
}))

export const AdditionalLinksWrapper = styled('div', ({ $theme }) => ({
    display: 'flex',
    flexDirection: 'column',
    marginTop: '20px',

    [$theme.mediaQuery.large]: {
        gap: '14px'
    }
}))
